import { HashLink } from './hash-link.tsx';
import {
  RouterPathsMap,
  TRANSACTION_DETAILS_PATH,
  TRANSACTION_LIST_PATH,
} from '../../router/paths.tsx';
import { buildRouterPath } from '../../router/utils.tsx';

export const TransactionHashLink = ({ hash, isDetails = false }) => {
  const path: string = isDetails
    ? TRANSACTION_DETAILS_PATH
    : TRANSACTION_LIST_PATH;

  return (
    <HashLink
      href={buildRouterPath(
        path as keyof RouterPathsMap,
        { id: hash },
        undefined
      )}
      hash={hash}
    />
  );
};
